module.exports = __webpack_public_path__ + "img/72.ec2ca82d.png";